export const EventType = {
  PARTY: 'Party',
  IN_PERSON_EVENT: 'In-Person Event',
  FACEBOOK_PARTY: 'Facebook Party',
  WHATS_APP_PARTY: 'WhatsApp Party',
} as const

export type EventTypeType = typeof EventType[keyof typeof EventType]

// Event type names are free text in SFA_EVENT_TYPES, so match ignoring case, spaces and
// punctuation (e.g. "Whatsapp-Party" and "WhatsApp Party" both map to the same label)
const normalizeEventType = (eventType: string): string => eventType.toLowerCase().replace(/[^a-z0-9]/g, '')

export function getEventTypeLabelKey(eventType: string): string {
  const map: Record<string, string> = {
    [normalizeEventType(EventType.PARTY)]: 'eventTypes.Party',
    [normalizeEventType(EventType.IN_PERSON_EVENT)]: 'eventTypes.InPersonEvent',
    [normalizeEventType(EventType.FACEBOOK_PARTY)]: 'eventTypes.FacebookParty',
    [normalizeEventType(EventType.WHATS_APP_PARTY)]: 'eventTypes.WhatsAppParty',
  }
  return map[normalizeEventType(eventType ?? '')] ?? 'eventTypes.Unknown'
}
